<template>
	<h1>Ajouter un theme de question pour fiche d'exercise</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="Difficulty">Theme de question</label>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="QuestionTheme"
				placeholder="QuestionTheme"
			/>
			<p v-if="status !== ''" class="status">{{ status }}</p>
			<p class="errors">{{ errors }}</p>
		</div>

		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	data() {
		return {
			form: {
				name: '',
			},
			errors: '',
			status: ''
		}
	},
	methods: {
		submit() {
			authenticatedApiFetch(`/exercise-question-themes/`, { method: 'POST', body: JSON.stringify(this.form) })
				.then(() => {
					this.status = 'Enregistré avec succès'
					this.form.name = ""
					setTimeout(() => {
						this.status = ''
					}, 2000)
					this.$store.dispatch('getExerciseQuestionThemes')
				})
				.catch((error) => {
					this.errors = error
				})
		},
	},
}
</script>

<style>
</style>
